import { ExportLicense } from 'api/ExportHubAPI';

/**
 * A license covers its destination country + country of ultimate destination
 * (from request_details). Coverage = the product's effective destinations are
 * all within the license's covered set (spec §8.5). As of Slice 9, callers pass
 * the product's *effective* destinations (intended ∪ linked Customer/Consignee/
 * End-User entity countries; see entityPresets.computeEffectiveDestinations).
 */
export const licenseCoveredCountries = (l: ExportLicense): string[] => {
  const rd = (l.request_details || {}) as Record<string, unknown>;
  const set = new Set<string>();
  const add = (v: unknown) => {
    if (typeof v === 'string' && v.trim()) set.add(v.trim());
  };
  add(rd.country);
  add(rd.country_of_ultimate_destination);
  return Array.from(set);
};

export const computeCoverage = (
  l: ExportLicense,
  destinations: string[],
): { covered: boolean; missing: string[] } => {
  const covered = licenseCoveredCountries(l).map((c) => c.toLowerCase());
  const missing = destinations.filter(
    (d) => d && !covered.includes(d.toLowerCase()),
  );
  return { covered: missing.length === 0, missing: missing };
};
